
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import VideoDetailPage from '../pages/video-detail/page';

const Home = lazy(() => import('../pages/home/page'));
const Viewer = lazy(() => import('../pages/viewer/page'));
const VideoPartPage = lazy(() => import('../pages/video-part/page'));
const VideoGalleryPage = lazy(() => import('../pages/video-gallery/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/viewer',
    element: <Viewer />,
  },
  {
    path: '/video-part',
    element: <VideoPartPage />,
  },
  {
    path: '/video-gallery',
    element: <VideoGalleryPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/video-detail',
    element: <VideoDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
